// extracted by mini-css-extract-plugin
module.exports = {"copyright":"Footer_copyright__1fKJo","terms":"Footer_terms__3UYw9","landSwitcher":"Footer_landSwitcher__3b83A","footer":"Footer_footer__1kgI5"};